import React, { Suspense } from 'react';
import MyRouter from 'routers/index';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const App: React.FC = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <title>Instaacard : Redefining Access with NFC Technology</title>
                <meta name="description" content="Instaacard : Redefining Access with NFC Technology" />
            </Helmet>
            <Suspense fallback={null}>
                <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
                    <MyRouter />
                </div>
            </Suspense>
        </HelmetProvider>
    );
};

export default App;
